import { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import { getOracle } from '../../utils/contractHelpers';

export const useOracleTimeExtended = () => {
    const web3 = useWeb3();

    const getNoOfTimeExtended = useCallback(async (resolverAddress) => {
        const contract = getOracle(resolverAddress, web3)
        try { 
            const extendedNumber = await contract?.methods?.timeExtended()?.call();
            return extendedNumber;
        } catch (e) {
            console.error("Transaction error:", e.message || e);
            throw e;
        }
    }, [web3]);
    return { getNoOfTimeExtended };
};

export default useOracleTimeExtended;
